import { Controller } from "@hotwired/stimulus";
import IMask from "imask";

export default class extends Controller {
  static values = {
    params: { type: Object, default: {} },
  };

  connect() {
    var masks = {
      weight: {
        mask: Number,
        scale: 3,
        radix: ".",
        thousandsSeparator: ",",
        padFractionalZeros: false,
        min: 0,
        max: 1000,
      },
    };

    var mask = this.element.dataset?.mask;
    var current_mask = masks?.[mask] || this.element.dataset;

    IMask(this.element, { ...current_mask, ...this.paramsValue });
  }
}
